class SearchNavigationLinkController {
    constructor(searchService) {
        this.searchService = searchService;
    }
}

SearchNavigationLinkController.$inject = ['SearchService'];

const searchNavigationLinkComponentDefinition = {
    bindings: {
        count: '<',
        isDisabled: '<',
        sref: '@',
        linkText: '@',
        classModifier: '@?',
    },
    controller: SearchNavigationLinkController,
    template: require('./search-navigation-link.component.html').trim(),
};

module.exports = {
    SearchNavigationLinkController,
    searchNavigationLinkComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/search/search-navigation-link.component.js